import React from 'react';

/*
 * BirdCourier
 * An original, lightweight SVG of a small round courier bird — the
 * portfolio's recurring motif. Purely decorative (aria-hidden); all
 * meaningful copy lives in real HTML next to it. No external assets,
 * no copyrighted characters.
 *
 * `carry` swaps the small item in its beak/claws so the same character can
 * strike a different pose per chapter:
 *   'letter' – delivering an envelope (default)
 *   'none'   – empty-beaked, for perching
 *   'ticket' – holding a little date/label ticket
 */
function BirdCourier({ className = '', width = 96, carry = 'letter' }) {
  return (
    <svg
      className={className}
      width={width}
      height={width}
      viewBox="0 0 96 96"
      fill="none"
      aria-hidden="true"
      focusable="false"
    >
      {/* soft ground shadow */}
      <ellipse cx="48" cy="86" rx="24" ry="4.5" fill="rgba(56,68,62,0.12)" />

      {/* tail */}
      <path
        d="M20 52c-8 1-13 6-15 11 6 1 11-1 15-4z"
        fill="#8fb4cb"
        stroke="#38443e"
        strokeWidth="1.6"
        strokeLinejoin="round"
      />

      {/* body */}
      <path
        d="M66 46c0 15-12 25-27 25S15 61 15 46 27 21 42 22c13 1 24 9 24 24z"
        fill="#a9c7d8"
        stroke="#38443e"
        strokeWidth="1.8"
        strokeLinejoin="round"
      />

      {/* belly */}
      <path
        d="M24 52c2 11 10 17 19 17 6 0 11-3 14-8-6-4-13-6-20-6-5 0-9 .3-13-.3z"
        fill="#fff9ef"
      />

      {/* wing */}
      <path
        d="M50 40c7-2 13 0 16 4-3 6-9 9-16 8-3-4-3-9 0-12z"
        fill="#8fb4cb"
        stroke="#38443e"
        strokeWidth="1.6"
        strokeLinejoin="round"
      />

      {/* head crest tuft */}
      <path d="M40 20c1-4 2-7 4-9 1 3 1 6 0 9z" fill="#8fb4cb" />
      <path d="M45 19c2-3 4-5 6-6 0 3-1 5-3 8z" fill="#8fb4cb" />

      {/* eye */}
      <circle cx="34" cy="40" r="3" fill="#38443e" />
      <circle cx="35" cy="39" r="1" fill="#fff9ef" />

      {/* cheek */}
      <circle cx="27" cy="45" r="3.4" fill="#e5b8ae" opacity="0.85" />

      {/* beak */}
      <path
        d="M18 42l-8 2 8 3z"
        fill="#d6a65e"
        stroke="#b9863c"
        strokeWidth="1.2"
        strokeLinejoin="round"
      />

      {/* the letter it carries */}
      {carry === 'letter' && (
        <g>
          <rect
            x="46"
            y="56"
            width="26"
            height="18"
            rx="2.5"
            fill="#fffdf8"
            stroke="#38443e"
            strokeWidth="1.6"
            transform="rotate(-8 59 65)"
          />
          <path
            d="M47 58l12 7 12-9"
            fill="none"
            stroke="#b9863c"
            strokeWidth="1.6"
            strokeLinecap="round"
            transform="rotate(-8 59 65)"
          />
        </g>
      )}

      {/* a small ticket / label on a string */}
      {carry === 'ticket' && (
        <g transform="rotate(-6 60 66)">
          <path d="M45 54l14 8" stroke="#38443e" strokeWidth="1.2" />
          <rect
            x="50"
            y="58"
            width="26"
            height="16"
            rx="3"
            fill="#fdf4df"
            stroke="#38443e"
            strokeWidth="1.6"
          />
          <circle cx="53" cy="61" r="1.4" fill="#38443e" />
          <path d="M58 66h14" stroke="#b9863c" strokeWidth="1.6" strokeLinecap="round" />
        </g>
      )}

      {/* little feet */}
      <path d="M38 70v6M46 70v6" stroke="#d6a65e" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}

export default BirdCourier;
